// API Configuration
// This file centralizes all API endpoint configurations

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002';

export const API_ENDPOINTS = {
  BASE: API_BASE_URL,

  // Auth
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    RESEND_CONFIRMATION: `${API_BASE_URL}/api/auth/resend-confirmation`,
    LOGOUT: `${API_BASE_URL}/api/auth/logout`,
  },

  // Bookings
  BOOKINGS: `${API_BASE_URL}/api/bookings`,

  // Lockers
  LOCKERS: `${API_BASE_URL}/api/lockers`,

  // Locations
  LOCATIONS: `${API_BASE_URL}/api/locations`,

  // Users
  USERS: `${API_BASE_URL}/api/users`,

  // Escrow
  ESCROW: {
    BASE: `${API_BASE_URL}/api/escrow`,
    BILLS: `${API_BASE_URL}/api/escrow/bills`,
    REQUESTS: `${API_BASE_URL}/api/escrow/requests`,
  },

  // Errands
  ERRANDS: `${API_BASE_URL}/api/couriers/errands`,

  // Courier
  COURIER: {
    BASE: `${API_BASE_URL}/api/couriers`,
    DELIVERIES: `${API_BASE_URL}/api/couriers/deliveries`,
    EARNINGS: `${API_BASE_URL}/api/couriers/earnings`,
  },

  // Stalls
  STALLS: {
    BASE: `${API_BASE_URL}/api/stalls`,
    VENDORS: `${API_BASE_URL}/api/stalls/vendors`,
    ACCESS: `${API_BASE_URL}/api/stalls/access`,
  },

  // Tokens
  TOKENS: {
    BASE: `${API_BASE_URL}/api/tokens`,
    VOUCHERS: `${API_BASE_URL}/api/tokens/vouchers`,
  },

  // Admin
  ADMIN: {
    BASE: `${API_BASE_URL}/api/admin`,
    USERS: `${API_BASE_URL}/api/admin/users`,
    BOOKINGS: `${API_BASE_URL}/api/admin/bookings`,
    LOCKERS: `${API_BASE_URL}/api/admin/lockers`,
    LOCATIONS: `${API_BASE_URL}/api/admin/locations`,
    PAYMENTS: `${API_BASE_URL}/api/admin/payments`,
    ANALYTICS: `${API_BASE_URL}/api/analytics`,
    ESCROW: `${API_BASE_URL}/api/admin/escrow`,
  },

  // Payments
  PAYMENTS: `${API_BASE_URL}/api/payments`,

  // Support
  SUPPORT: {
    BASE: `${API_BASE_URL}/api/support`,
    CATEGORIES: `${API_BASE_URL}/api/support/categories`,
    TICKETS: `${API_BASE_URL}/api/support/tickets`,
  },

  // Notifications (Supabase direct)
  NOTIFICATIONS: 'notifications',

  // Chat (Supabase direct)
  CHAT: 'errand_chat_messages',
};

export default API_ENDPOINTS;
